module.exports = __webpack_public_path__ + "static/media/2.015a356c.jpg";